import { styled } from 'styled-components';

export const Wrapper = styled.div`
    color: var(--color-error);
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;
